import { render, staticRenderFns } from "./FormaPagamentoAdd.vue?vue&type=template&id=57cf9ba0"
import script from "./FormaPagamentoAdd.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports